import { axios } from '@/utils/request'

export function getMediaLibrary(parameter) {
    return axios({
        url: '/media/',
        method: 'get',
        params: parameter
    })
}
